import { render } from "./UiAlert.vue?vue&type=template&id=7248d2dc&ts=true"
import script from "./UiAlert.vue?vue&type=script&lang=ts"
export * from "./UiAlert.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__